import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection, Text } from "@cinch-labs/design-system";
import { getStoryblokImageServiceUrl, storyblokEditable } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./intro.module.css";
export const Intro = (blok)=>{
    const { title , body , image  } = blok;
    return /*#__PURE__*/ _jsxs("section", {
        ...storyblokEditable(blok),
        children: [
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "xxl",
                fontWeight: "bold",
                element: "h2",
                lineHeight: "display",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                children: renderWithResolver(body)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: /*#__PURE__*/ _jsx("img", {
                    src: getStoryblokImageServiceUrl(image.filename, {
                        width: 900,
                        filters: [
                            {
                                quality: 50
                            }
                        ]
                    }),
                    className: styles.image,
                    alt: image.alt ?? undefined
                })
            })
        ]
    });
};
